import { Injectable } from '@angular/core';
import { MultimediaTypes } from 'src/app/common/enums/enums';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MultimediahandlerService {

  acceptFileImageType = environment.ACCEPTED_IMAGE_FILE_TYPE;
  acceptAudioFileType = environment.ACCEPTED_AUDIO_FILE_TYPE;
  acceptVideoFileType = environment.ACCEPTED_VIDEO_FILE_TYPE;
  acceptDocumentFileType = environment.ACCEPTED_DOCUMENTS_FILE_TYPE;

  mediaTypeWithURL: any;

  constructor() {

  }

  getMediaType(file) {
    try {
      var fileName = file.file.name.split('.').pop();
    }
    catch (e) {
      var fileName = file.name.split('.').pop();
    }
    fileName = fileName.toLowerCase();

    if (this.acceptFileImageType.some(x => x === fileName)) {
      var mediaType = MultimediaTypes.PHOTO;
      this.mediaTypeWithURL = {
        type: mediaType,
        url: null
      } as any;
    }
    else if (this.acceptAudioFileType.some(x => x === fileName)) {
      var mediaType = MultimediaTypes.AUDIO;
      this.mediaTypeWithURL = {
        type: mediaType,
        url: "../../../../../assets/nonimage-preview/Large-Icons/media_type_2.png"
      } as any;
    }
    else if (this.acceptVideoFileType.some(x => x === fileName)) {
      var mediaType = MultimediaTypes.VIDEO;
      this.mediaTypeWithURL = {
        type: mediaType,
        url: "../../../../../assets/nonimage-preview/Large-Icons/media_type_3.png"
      } as any;
    }
    else if (this.acceptDocumentFileType.some(x => x === fileName)) {
      var mediaType = MultimediaTypes.DOC;
      this.mediaTypeWithURL = {
        type: mediaType,
        url: "../../../../../assets/nonimage-preview/Large-Icons/media_type_4.png"
      } as any;
    }
    else {
      var mediaType = MultimediaTypes.UNKNOWN;
      this.mediaTypeWithURL = {
        type: mediaType,
        url: null
      } as any;
    }
    return this.mediaTypeWithURL;
  }
}
